export interface Comic {
  id: string;
  title: string;
  author: string;
  coverUrl: string;
  tags: string[];
  chapterCount: number;
  updateDate: string;
  status: '连载中' | '已完结';
  description: string;
  rating: number;
  views: number;
}

export const categoryTags = [
  { key: 'romance', label: '恋爱', icon: 'ri-heart-line' },
  { key: 'suspense', label: '悬疑', icon: 'ri-search-eye-line' },
  { key: 'action', label: '动作', icon: 'ri-flashlight-line' },
  { key: 'fantasy', label: '奇幻', icon: 'ri-magic-line' },
  { key: 'comedy', label: '喜剧', icon: 'ri-emotion-happy-line' },
  { key: 'drama', label: '剧情', icon: 'ri-film-line' },
  { key: 'thriller', label: '惊悚', icon: 'ri-ghost-line' },
  { key: 'school', label: '校园', icon: 'ri-building-line' },
];

export const hotComics: Comic[] = [
  {
    id: 'secret-class',
    title: '秘密课堂',
    author: 'Li Soo-young',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20and%20man%20in%20a%20classroom%20setting%2C%20romantic%20drama%20cover%20art%2C%20warm%20amber%20lighting%2C%20soft%20watercolor%20texture%2C%20elegant%20composition%2C%20manga%20cover%20style%20with%20clean%20background%2C%20delicate%20lineart%2C%20emotional%20atmosphere&width=600&height=800&seq=comic-secret-class&orientation=portrait',
    tags: ['romance', 'drama'],
    chapterCount: 86,
    updateDate: '2026-07-06',
    status: '连载中',
    description: '一段禁忌的师生关系，在秘密的课堂中悄然展开。他以为自己是掌控者，却发现自己早已深陷无法自拔。',
    rating: 9.5,
    views: 1250000,
  },
  {
    id: 'solo-leveling',
    title: '我独自升级',
    author: 'Chugong',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20a%20powerful%20male%20warrior%20with%20dark%20armor%20and%20glowing%20eyes%2C%20dungeon%20monster%20background%2C%20epic%20fantasy%20style%2C%20dramatic%20lighting%20with%20purple%20shadows%2C%20clean%20clean%20background%2C%20manga%20cover%20illustration&width=600&height=800&seq=comic-solo-leveling&orientation=portrait',
    tags: ['action', 'fantasy'],
    chapterCount: 200,
    updateDate: '2026-07-05',
    status: '已完结',
    description: '在最危险的副本中，他从最弱猎人成长为最强存在。独自一人，也能突破极限。',
    rating: 9.8,
    views: 8500000,
  },
  {
    id: 'true-beauty',
    title: '女神降临',
    author: 'Yaongyi',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20a%20beautiful%20young%20woman%20with%20long%20hair%20and%20natural%20makeup%20look%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20delicate%20illustration%20style%2C%20clean%20simple%20background%2C%20manga%20cover%20design&width=600&height=800&seq=comic-true-beauty&orientation=portrait',
    tags: ['romance', 'school', 'comedy'],
    chapterCount: 256,
    updateDate: '2026-07-04',
    status: '已完结',
    description: '通过化妆技巧改变命运的少女，在两个男孩之间徘徊。美丽外表下隐藏的真实自我，何时才能被真正看见？',
    rating: 9.3,
    views: 6800000,
  },
  {
    id: 'tower-of-god',
    title: '神之塔',
    author: 'SIU',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20cover%20art%2C%20a%20mysterious%20massive%20tower%20rising%20into%20the%20sky%2C%20silhouette%20of%20a%20young%20boy%20at%20the%20base%2C%20epic%20scale%2C%20warm%20golden%20light%20from%20above%2C%20atmospheric%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-tower-god&orientation=portrait',
    tags: ['fantasy', 'action', 'drama'],
    chapterCount: 580,
    updateDate: '2026-07-06',
    status: '连载中',
    description: '追寻唯一的朋友进入神秘之塔，在层层考验中揭开幕后真相。登顶之日，便是真相大白之时。',
    rating: 9.6,
    views: 7200000,
  },
  {
    id: 'lookism',
    title: '外貌至上主义',
    author: 'Park Tae-jun',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%2C%20contrast%20between%20two%20male%20figures%20one%20handsome%20one%20plain%2C%20school%20setting%2C%20social%20commentary%20theme%2C%20warm%20lighting%2C%20clean%20illustration%20style%2C%20manga%20cover%20design&width=600&height=800&seq=comic-lookism&orientation=portrait',
    tags: ['drama', 'school', 'action'],
    chapterCount: 470,
    updateDate: '2026-07-05',
    status: '连载中',
    description: '一个拥有双重生活的高中生，白天是丑陋的胖男孩，夜晚是完美的美男子。在两个世界中，他逐渐找到了真正的自我。',
    rating: 9.4,
    views: 5600000,
  },
  {
    id: 'eleceed',
    title: '异能者',
    author: 'Son Jeho',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20superpower%20cover%20art%2C%20a%20young%20man%20with%20electric%20powers%20surrounded%20by%20blue%20energy%2C%20dynamic%20pose%2C%20urban%20night%20background%2C%20clean%20illustration%2C%20manga%20cover%20style%2C%20dramatic%20composition&width=600&height=800&seq=comic-eleceed&orientation=portrait',
    tags: ['action', 'fantasy', 'comedy'],
    chapterCount: 310,
    updateDate: '2026-07-03',
    status: '连载中',
    description: '拥有超能力的少年与一只神秘猫咪相遇，从此开启了异能者的奇幻旅程。',
    rating: 9.7,
    views: 4100000,
  },
  {
    id: 'sweet-home',
    title: '甜蜜家园',
    author: 'Kim Carnby',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20horror%20thriller%20cover%20art%2C%20an%20apartment%20building%20with%20dark%20ominous%20atmosphere%2C%20silhouette%20of%20a%20person%20looking%20out%20window%2C%20warm%20interior%20light%20contrasting%20dark%20exterior%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=comic-sweet-home&orientation=portrait',
    tags: ['thriller', 'drama', 'action'],
    chapterCount: 140,
    updateDate: '2026-07-01',
    status: '已完结',
    description: '在怪物横行的世界，被困在公寓中的人们必须面对内心最深层的恐惧才能生存下去。',
    rating: 9.4,
    views: 3900000,
  },
  {
    id: 'the-breaker',
    title: '破天录',
    author: 'Jeon Geuk-jin',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20cover%20art%2C%20a%20young%20fighter%20in%20dynamic%20combat%20pose%2C%20traditional%20Korean%20martial%20arts%20theme%2C%20dramatic%20brushstroke%20style%2C%20warm%20earthy%20tones%2C%20clean%20background%2C%20manga%20cover&width=600&height=800&seq=comic-breaker&orientation=portrait',
    tags: ['action', 'drama'],
    chapterCount: 72,
    updateDate: '2026-06-28',
    status: '连载中',
    description: '被欺凌的普通高中生，在一次意外中遇见一位神秘的武道宗师，从此踏上了武道之路。',
    rating: 9.2,
    views: 2100000,
  },
];

export const testimonials = [
  {
    id: '1',
    name: '小樱',
    username: '@xiaoying_reads',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20illustrated%20young%20woman%20avatar%20portrait%2C%20soft%20warm%20tones%2C%20gentle%20smile%2C%20simple%20clean%20background%2C%20anime%20inspired%20art%20style&width=120&height=120&seq=avatar-xiaoying&orientation=squarish',
    content: '韩漫网真的是我用过最舒服的漫画平台！下拉式阅读太流畅了，而且完全没有广告弹窗。之前在其他网站看漫经常被广告打断，体验很糟糕。这里每天都有更新，画质也非常清晰！',
    rating: 5,
  },
  {
    id: '2',
    name: '阿杰',
    username: '@ajie_manga',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20illustrated%20young%20man%20avatar%20portrait%2C%20casual%20look%2C%20warm%20tones%2C%20friendly%20expression%2C%20simple%20clean%20background%2C%20anime%20inspired&width=120&height=120&seq=avatar-ajie&orientation=squarish',
    content: '追了女神降临整整两年，终于在这里找到了全集！画质比我想象中好太多了。而且还支持手机和电脑两端同步，通勤路上也能看，简直不要太方便！推荐给所有韩漫同好！',
    rating: 5,
  },
  {
    id: '3',
    name: '漫画迷小雨',
    username: '@xiaoyu_comic',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20illustrated%20female%20avatar%20portrait%2C%20sweet%20expression%2C%20warm%20soft%20colors%2C%20simple%20background%2C%20anime%20inspired%20art%20style&width=120&height=120&seq=avatar-xiaoyu&orientation=squarish',
    content: '韩漫网的分类做得很好，想找什么类型的漫画都能快速定位。更新的速度也很快，每周都有新番上架。页面设计简洁好看，阅读体验很纯粹！',
    rating: 5,
  },
  {
    id: '4',
    name: '深夜读者',
    username: '@night_reader',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20illustrated%20male%20avatar%20portrait%2C%20calm%20expression%2C%20warm%20dark%20tones%2C%20simple%20background%2C%20anime%20inspired%20art&width=120&height=120&seq=avatar-night&orientation=squarish',
    content: '作为一个重度韩漫爱好者，我想说这个平台的质量真的没话说。界面干净利落，没有乱七八糟的弹窗，加载速度也很快。最喜欢这里的下拉式阅读模式！',
    rating: 5,
  },
  {
    id: '5',
    name: '星月',
    username: '@xingyue_reads',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20illustrated%20female%20avatar%20portrait%2C%20elegant%20look%2C%20warm%20pastel%20tones%2C%20simple%20clean%20background%2C%20anime%20inspired&width=120&height=120&seq=avatar-xingyue&orientation=squarish',
    content: '朋友推荐我来这里的，一试就爱上了。页面设计很温暖舒服，没有刺眼的广告。漫画种类也很全，想看的都有。已经安利给身边好几个朋友了！',
    rating: 5,
  },
];

export const faqItems = [
  {
    question: '韩漫网是否完全免费？',
    answer: '是的，韩漫网所有漫画内容均免费向读者开放。我们始终坚持零门槛阅读体验，不需要任何付费订阅或会员购买。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读是我们提供的流畅阅读体验。读者只需向下滑动页面，漫画内容会连续不断地呈现，无需翻页点击。这种模式特别适合手机端阅读，让您沉浸在漫画世界中。',
  },
  {
    question: '网站是否有广告？',
    answer: '韩漫网承诺全程无广告干扰。我们不在阅读页面放置任何弹窗、横幅或视频广告，确保您能专注于漫画内容本身。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '我们每日跟踪最新韩漫更新动态，第一时间同步上架。热门连载作品通常在源站更新后 24 小时内即可在韩漫网阅读。',
  },
];

export const brandAdvantages = [
  {
    icon: 'ri-vip-diamond-line',
    title: '全站免费',
    description: '所有漫画内容永久免费，无需付费订阅，零门槛畅享全站资源。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    description: '实时追踪最新韩漫动态，第一时间同步更新，永远不错过精彩章节。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '隐私保护',
    description: '无需注册即可阅读，保护您的隐私信息，安心享受阅读时光。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '完美适配手机、平板与电脑，随时随地无缝阅读体验。',
  },
  {
    icon: 'ri-file-copy-line',
    title: '高清画质',
    description: '所有漫画均采用高清图源，细节清晰可见，还原最佳阅读质量。',
  },
  {
    icon: 'ri-customer-service-line',
    title: '用户至上',
    description: '以读者体验为核心，持续优化平台功能与内容。',
  },
];